import React from 'react';

import TimerBox from '../timer-box';

interface IProps {
  turnerName?: string;
  startedTime?: number;
  status?: string;
}

const FixedSubjects: React.FC<IProps> = ({ turnerName, startedTime, status }) => (
  <div className="rounded-xl bg-white p-4 sm:m-3 sm:mx-0">
    <div className="flex flex-col items-center justify-between gap-y-2 sm:flex-row">
      <p>{turnerName}</p>
      <TimerBox status={status} time={startedTime} />
    </div>
  </div>
);

export default FixedSubjects;
